'use strict';

angular.module('BusinessUnitsControllers')

.controller('BusinessUnitsController', ['$scope', '$state', '$modal', 'topBar', 'searchService', 'authenticatedUser', 'adminBusinessUnitsService', 'businessUnits', '$translate',
                                function ($scope, $state, $modal, topBar, searchService, authenticatedUser, administrationService, businessUnits, $translate) {

        $translate('iam.admin.businessUnits.pageTitle').then(function(translation) {
            topBar.setTitle('<i class="fa fa-sitemap"></i><span> ' + translation + '</span>');
        });

        $scope.businessUnits = businessUnits;
        $scope.DepthColor = ['80', '115', '150', '185', '200', '200', '200', '200', '200'];
        $scope.synchronizationActive = false;

        // Search a business unit from query passed by search input
        $scope.searchBusinessUnits = function (searchTerm) {
            administrationService.searchBusinessUnits(searchTerm)
                                 .then(function (businessUnits) {
                                    $scope.businessUnits = businessUnits;
                                 });
        }

        // Enter a business unit to be updated
        $scope.updateBusinessUnit = function ($event, bu) {
            $state.go('adminBusinessUnits.businessUnitEdit', { BusinessUnitID: bu.BusinessUnitID });
        }

        // Enter a business unit to be created
        $scope.createBusinessUnit = function () {
            $state.go('adminBusinessUnits.businessUnitAdd');
        }

        $scope.SynchronizeBusinessUnitMembers = function () {
            $scope.synchronizationActive = true;
            administrationService.synchronizeUpdates()
                                 .then(function (res) { $scope.synchronizationActive = false });
        }
    }]);
